import React, { useState, useEffect } from 'react';
import BulkEditTableComponent from '../BulkEditTable/BulkEditTable';
import { API_URL } from '../../configs/Api';
import { getHeaders } from '../../middleware/Api';
import MessageList from './MessageList';
import { Button } from '@mui/material';

import styles from './styles.pcss';

type Props = {
  transactions: any;
  selectTransactionRow: Function;
  enqueueSnackbarCustomMessageHandler: Function;
};
export function TransactionTable(props: Props) {
  const [messages, setMessages] = useState<string[]>([]);
  const fixTransaction = async () => {
    try {
      const res = await sendFixTransactionRequest(selectedIds[0]);
      switch (res.type) {
        case 'data':
          setMessages(res.payload.messages);
      }
    } catch (e) { }
  };
  const transactions = props.transactions.transactions.map(
    ({
      postingDate,
      date,
      merchant,
      amount,
      ccNumber,
      id,
      isSelected,
    }: any) => ({
      isSelected,
      postingDate,
      date,
      merchant,
      amount,
      last4: ccNumber?.slice(-4) ?? '',
      id,
    }),
  );
  const shouldRenderTable =
    props.transactions.isLoading === false && transactions.length > 0;
  const handleSelectRow = (id: number) => {
    props.selectTransactionRow(id);
  };
  const selectedIds = transactions
    .filter((t: any) => t.isSelected)
    .map((t: any) => t.id);
  return (
    <>
      <>
        {shouldRenderTable && (
          <BulkEditTableComponent
            headers={[
              'postingDate',
              'date',
              'merchant',
              'amount',
              'last4',
              'id',
            ]}
            data={transactions}
            currentPage={1}
            totalPages={1}
            onClickNextPage={() => { }}
            onClickPreviousPage={() => { }}
            onSelectRow={handleSelectRow}
          />
        )}
        <div>
          <Button
            className={styles.button}
            size="small"
            variant="contained"
            color="primary"
          >
            Transaction Not In List?
          </Button>
          {selectedIds.length === 1 && (
            <Button
              className={styles.button}
              size="small"
              variant="contained"
              color="primary"
              onClick={() => fixTransaction()}
            >
              Fix Transaction
            </Button>
          )}
        </div>
      </>
      <MessageList messages={messages} />
    </>
  );
}

async function sendFixTransactionRequest(id: string) {
  return (
    await fetch(API_URL + `transactions/${id}/fix`, {
      method: 'put',
      headers: getHeaders(),
      body: '',
    })
  ).json();
}
